module.exports = __webpack_public_path__ + "img/live-video-streaming.dc0ac960.webp";